 import React from "react";
import { Link } from "react-router-dom"; 
 
import "./AboutVibe.css";
import awarenessImg from "../assets/awarenessImg.jpg";
import awarenessImg2 from "../assets/awarenessImg2.jpg";

import {
  FaHandsHelping,
  FaLeaf,
  FaGlobeAsia
} from "react-icons/fa";

const AboutEcoVibe = () => {
  return (
    <section className="about-section">
      <div className="about-wrapper">

        <div className="media-area">
          <div className="media-back">
            <img src={awarenessImg} alt="Awareness Back" />
          </div>
          <div className="media-front">
            <img src={awarenessImg2} alt="Awareness Front" />
          </div>
        </div>

        <div className="about-text">
          <h2>Environmental Awareness for a Better Tomorrow</h2>
          <p>
            EcoVibe empowers individuals to understand environmental challenges
            and take meaningful actions. Join us in creating a cleaner,
            greener, and more sustainable future.
          </p>

          <div className="awareness-features">
            <div className="feature">
              <FaLeaf className="icon" />
              <span>Eco Friendly Actions</span>
            </div>
            <div className="feature">
              <FaGlobeAsia className="icon" />
              <span>Protect Our Planet</span>
            </div>
            <div className="feature">
              <FaHandsHelping className="icon" />
              <span>Volunteer Support</span>
            </div>
          </div>

          <div className="btn-group">
            <Link to="/awareness/sunlight">
              <button className="view-btn">View Awareness</button>
            </Link>

            
            <Link to="/create-blog">
              <button className="upload-btn">Upload Awareness</button>
            </Link>
          </div>

          <p className="stats-text">
            🌍 Join <b>100+ people</b> already taking action.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AboutEcoVibe